module.exports = __webpack_public_path__ + "img/rhythm_bg1.69c96b3e.png";